

/**
 *   CF7 Leads Form
 */

module.exports = function () {

    return function (app) {
        cf7LeadsForm()
    }
  
    function cf7LeadsForm() {
        //if(jQuery('.m-cf7leadsForm').length > 0) {
        const checkForForm = document.querySelector(".m-cf7leadsForm");

        if(typeof(checkForForm) != 'undefined' && checkForForm != null) {
            const listItems = document.querySelectorAll(".m-cf7leadsList li");
            for (const listItem of listItems) {
                listItem.addEventListener('click', function(event) {
                    event.preventDefault();
                    var lead = event.target.innerText;
                    document.getElementById('m-cf7leadsSelected').value = lead;
                    document.querySelector('.m-cf7leadsFormfields h2').innerHTML = lead;

                    this.parentNode.classList.add('cf7-slide-out');
                    //jQuery('.m-cf7leadsList').addClass('cf7-slide-out');
                    document.querySelector('.m-cf7leadsFormfields').classList.add('cf7-slide-in');
                    //jQuery('.m-cf7leadsFormfields').addClass('cf7-slide-in');
                    document.querySelector('.m-cf7leadsForm').style.height = document.querySelector('.m-cf7leadsFormfields').offsetHeight + 'px';
                    //jQuery('.m-cf7leadsForm').height(jQuery('.m-cf7leadsFormfields').height());
              }, false);
            }
            
            jQuery('.m-cf7leadsBackButton').click(function(){
                document.querySelector('.m-cf7leadsList').classList.remove('cf7-slide-out');
                //jQuery('.m-cf7leadsList').removeClass('cf7-slide-out');
                document.querySelector('.m-cf7leadsFormfields').classList.remove('cf7-slide-in');
                //jQuery('.m-cf7leadsFormfields').removeClass('cf7-slide-in');
                document.querySelector('.m-cf7leadsForm').style.height = document.querySelector('.m-cf7leadsList').offsetHeight + 'px';
                //jQuery('.m-cf7leadsForm').height(jQuery('.m-cf7leadsList').height());
            });
        }
    }
}
  